import type { RouteObject } from "react-router";

import AuthLayout from "@/modules/auth-layout";
import LoginPage from "@/modules/login-page";
import { PageError } from "@/modules/page-error";

import { AuthRouteGate } from "./router-auth-routes.component";

export const AUTH_ROUTES: RouteObject[] = [
  {
    path: "auth",
    element: (
      <AuthRouteGate>
        <AuthLayout />
      </AuthRouteGate>
    ),
    children: [
      { path: "login", element: <LoginPage /> },
      { path: "*", element: <PageError status={404} isAuth /> },
    ],
  },
];
